import React from 'react';
import Swiperslider from '../Swiperslider/Index';
import ImageTag from '../ImageTag/Index';
import '../Heroslider/index.css';
import BusinessEnquiry from '../Forms/BusinessEnquiry';
import spinwindLogo from '../../images/spin-win.webp'
import { motion } from 'framer-motion';

const Index = ({ Data, Data2 }) => {
  const splitText = (text, startDelay = 0) => {
    if (!text) return null;
    return text.split('').map((char, index) => (
      <motion.span
        key={index}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: startDelay + index * 0.05, duration: 0.3 }}
      >
        {char === ' ' ? '\u00A0' : char}
      </motion.span>
    ));
  };

  return (
    <section className='w-full flex flex-wrap flex-center overflow-hidden heroSlider'>
      <Swiperslider
        spaceBetween={1}
        slidesPerView={1}
        navigation={true}
        pagination={{ clickable: true }}
        timeDelay={'8000'}
        effect={'fade'}
      >
        {Array.isArray(Data) && Data.length > 0 ? (
          Data.map((slide, index) => (
            <div
              className={`col-12 float-start slideParent position-relative`}
              key={index}
            >
              {/* Background Images */}
              <div className='col-12 float-start'>
                <ImageTag
                  ImagePath={slide.imagePath}
                  ImageAlt={slide.imageAlt}
                  ImageClass={'w-screen h-screen desktop-show'}
                />
                <ImageTag
                  ImagePath={slide.mobimgPath}
                  ImageAlt={slide.imageAlt}
                  ImageClass={'w-100 h-100vh mobile-show'}
                />
              </div>

              {/* Slide Content */}
              <div className='hidden slideCenter position-center bg-black-500 px-sm-4 py-sm-2'>

                {/* Heading - animates letter by letter immediately */}
                {slide.heading && (
                  <h1 className='text-white'>
                    {splitText(slide.heading, 0)}
                  </h1>
                )}

                {/* Title - starts after heading finishes */}
                {slide.title && (
                  <h2 className='text-white'>
                    {splitText(slide.title, 0.5)}
                  </h2>
                )}

                {/* Description - fades in last as full line */}
                {slide.descp && (
                  <motion.p
                    className='text-white'
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1.2, duration: 0.6 }}
                  >
                    {slide.descp}
                  </motion.p>
                )}

              </div>
            </div>
          ))
        ) : null}
      </Swiperslider>
        <section className="w-full flex flex-wrap justify-center mx-auto">
          <div className="w-full flex-wrap flex justify-center relative md:top-[-25px] z-50">
            <ImageTag
              ImagePath={spinwindLogo}
              ImageClass={'2xl:w-[500px] mx-auto md:w-[400px] w-full md:rounded-[25px]'}
            />
            </div>
        </section>
      {/* Highlights Bar */}
      {/* <Container _parentClass="w-full flex flex-wrap primary-bg py-sm-5 py-4">
        <div className="w-full lg:w-[1340px] gap-sm-3 m-auto flex-wrap flex text-white highlights">
          {Array.isArray(Data2) && Data2.map((highlight, index) => (
            <motion.div
              key={index}
              className={`w-full lg:w-1/5 border-right`}
              data-aos="fade-up"
              data-aos-offset="100"
              data-aos-duration="500"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
            >
              <span>{highlight.label}</span>
              <p>{highlight.value}</p>
            </motion.div>
          ))}
        </div>
      </Container> */}

      {/* Business Enquiry Form */}
      <BusinessEnquiry layout="secondary" source = 'header'  titleStyle={{ textAlign: 'center' }} />
    </section>
  );
};

export default Index;